import { render, staticRenderFns } from "./zonglan.vue?vue&type=template&id=fc80cc20"
import script from "./zonglan.vue?vue&type=script&lang=js"
export * from "./zonglan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports